import Loadable from 'react/components/loadable';

const ConfirmLateAbsentModal = Loadable({
  loader: () => import('../../pages/calendar/confirm_late_absent_modal'),
  type: 'modal',
});

angular.module('shared').value('ConfirmLateAbsentModal', ConfirmLateAbsentModal);
